(() => {
    class AttributeHandler {
        constructor() {
            this.requiredInputArr = Array.from(document.querySelectorAll('[data-attribute-required]'));
            this.checkoutButtonContainer = document.querySelector('[data-cart-checkout-buttons');

            this.birthInput = document.querySelector('input[name="attributes[BIRTHDATE]"]');

            console.log('attibute hadnler init:', {
                checkoutButtonContainer: this.checkoutButtonContainer,
                requiredInputArr: this.requiredInputArr,
                birthInput: this.birthInput
            });

            this.blockingPlate = this.createBlockingPlate();

            this.blockingPlate.addEventListener('click', this.handleBlockingPlateClick.bind(this));

            this.requiredInputArr.forEach((el) =>
                el.addEventListener('change', this.handleInputChange.bind(this))
            );
        }

        createBlockingPlate() {
            const el = document.createElement('div');

            el.classList.add('blocking-plate');
            this.checkoutButtonContainer.classList.add('relative');

            this.checkoutButtonContainer.appendChild(el);

            return el;
        }

        handleBlockingPlateClick() {
            if (this.allInvalidInputs.length > 0) {
                this.allInvalidInputs.forEach((el, index) => {
                    el.classList.add('error');
                    if (index === 0) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            } else if (!this.hasValidBirthdate) {
                this.birthInput.classList.add('error');
                this.birthInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                console.warn('Blocked when no invalid fields found.');
            }
        }

        handleInputChange(evt) {
            this.blockingPlate.classList.toggle('hidden', !this.shouldBlock);
            console.log('handleInputChange', { evt, shoudBLock: this.shouldBlock });
            evt.target.classList.remove('error');
        }

        get allInvalidInputs() {
            return this.requiredInputArr.filter((el) => el.value === '' || el.value === 'no-select');
        }

        get hasValidBirthdate() {
            if (!this.birthInput) return true;

            const birthdate = this.birthInput.value;

            return this.isOver18(birthdate);
        }

        get shouldBlock() {
            return this.allInvalidInputs.length > 0 || !this.hasValidBirthdate;
        }

        isOver18(birthdate) {
            const today = new Date();
            const birthDate = new Date(birthdate);
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDifference = today.getMonth() - birthDate.getMonth();
            if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age >= 18;
        }
    }

    new AttributeHandler();
})();
